const DATA_SAVED = "extragestor/cobros/DATA_SAVED";
const RESET_DATA_SAVED = "extragestor/cobros/RESET_DATA_SAVED";
const FETCH_LISTADO = "extragestor/cobros/FETCH_LISTADO";
const FETCH_DETALLE = "extragestor/cobros/FETCH_DETALLE";
const RESET_DETALLE = "extragestor/cobros/RESET_DETALLE";
const REMOVED = "extragestor/cobros/REMOVED";
const RESET = "extragestor/cobros/RESET";
const PUT_ACTIVIDAD_SELECCIONADA =
  "extragestos/cobros/PUT_ACTIVIDAD_SELECCIONADA";
const CLEAR_ACTIVIDAD_SELECCIONADA =
  "extragestos/cobros/CLEAR_ACTIVIDAD_SELECCIONADA";
/*---*/
export {
  DATA_SAVED,
  RESET_DATA_SAVED,
  FETCH_LISTADO,
  REMOVED,
  RESET,
  FETCH_DETALLE,
  RESET_DETALLE,
  PUT_ACTIVIDAD_SELECCIONADA,
  CLEAR_ACTIVIDAD_SELECCIONADA
};



// WEBPACK FOOTER //
// ./src/ducks/cobros/types.js